var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"supplier-link",class:_vm.site,style:(_vm.color ? { color: ("#" + _vm.color) } : ''),attrs:{"href":_vm.url}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }